module.exports = __webpack_public_path__ + "img/customer2.d31e8aa6.svg";